/**
 * Metadato para filtros y configuraciones
 */
export default class Metadato {
  /** @type {String} */ campo
  /** @type {Number|undefined} */ operador
  /** @type {String} */ valor
}
